import type { ReactElement } from 'react';
import { useState } from 'react';

interface ProductionOrderSheetThumbnailProps {
  readonly url: string;
  /** 그림을 불러왔거나 불러오지 못했을 때 — 인쇄 시점을 잡는 데 쓴다. */
  readonly onSettled?: () => void;
}

/** 발주서 시안 이미지 — 인쇄 전에 확실히 불러오도록 즉시 로딩한다. 실패하면 "미리보기 준비 중". */
export const ProductionOrderSheetThumbnail = ({
  url,
  onSettled,
}: ProductionOrderSheetThumbnailProps): ReactElement => {
  const [failed, setFailed] = useState(false);

  if (failed) return <p className="text-sm">미리보기 준비 중</p>;
  return (
    <img
      src={url}
      alt="디자인 시안 앞면"
      loading="eager"
      className="max-w-xs object-contain"
      onLoad={() => onSettled?.()}
      onError={() => {
        setFailed(true);
        onSettled?.();
      }}
    />
  );
};
